var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('Card',{attrs:{"title":'Ubah Penggajian'},scopedSlots:_vm._u([{key:"body",fn:function(){return [(_vm.dataLoaded == true)?_c('Form',{attrs:{"form":_vm.form,"route":'payrolls/'+_vm.form.id,"employeeID":_vm.employeeID,"isEdit":true}}):_vm._e()]},proxy:true}])})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }